import { Command } from 'commands/Commands';

export class ChangeArticleBody extends Command {
  type: string = 'BlogArticle.ChangeBody';
  constructor(id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
